<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de {{ termKey.AssistancePlural | term }}</h1>
    </div>
    <br />
    <div class="card-header">
      <button
        id=""
        class="primary-button"
        appPermision="/assistance+c"
        (click)="createAssistance()"
      >
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            multiTemplateDataRows
            [dataSource]="
              (asyncAssistance | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="controls">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let assistance">
                <a
                  mat-icon-a
                  (click)="toggleServices(assistance)"
                  [attr.aria-label]="
                    isExpanded(assistance.id) ? 'Ocultar servicios' : 'Ver servicios'
                  "
                >
                  <mat-icon class="main-icon">{{
                    isExpanded(assistance.id) ? 'expand_less' : 'chevron_right'
                  }}</mat-icon>
                </a>
                <a
                  mat-icon-a
                  [matMenuTriggerFor]="assistanceMenu"
                  aria-label="Acciones"
                  title="Acciones"
                >
                  <mat-icon class="main-icon">menu</mat-icon>
                </a>
                <mat-menu #assistanceMenu="matMenu" class="icon-menu">
                  <button
                    mat-menu-item
                    appPermision="/assistance+u"
                    (click)="updateAssistance(assistance)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">edit</mat-icon> Editar
                      {{ termKey.AssistanceSingular | term }}</span
                    >
                  </button>
                  <button
                    mat-menu-item
                    class="icon-button"
                    appPermision="/assistance+u"
                    (click)="addAsistanceService(assistance)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">add_circle</mat-icon> Agregar
                      {{ termKey.AccompanimentServiceSingular | term }}</span
                    >
                  </button>
                  <mat-divider></mat-divider>
                  <button
                    mat-menu-item
                    class="icon-button"
                    appOnlysuperuser="/assistance"
                    (click)="eliminate(assistance)"
                  >
                    <span class="text-span delete-span"
                      ><mat-icon class="icon-size delete-icon">delete</mat-icon> Eliminar
                      {{ termKey.AssistanceSingular | term }}</span
                    >
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let assistance">
                {{ assistance.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let assistance">
                {{ assistance.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="population">
              <th mat-header-cell *matHeaderCellDef>Población</th>
              <td mat-cell *matCellDef="let assistance">
                {{ assistance.population }}
              </td>
            </ng-container>

            <ng-container matColumnDef="sector">
              <th mat-header-cell *matHeaderCellDef>{{ termKey.SectorSingular | term }}</th>

              <td mat-cell *matCellDef="let assistance">
                @if (assistance.sector?.length) {
                  <ul>
                    @for (sec of assistance.sector; track sec) {
                      <li>{{ sec.name }}</li>
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="sourceFoundings">
              <th mat-header-cell *matHeaderCellDef>Fuentes de financiación</th>
              <td mat-cell *matCellDef="let assistance">
                {{ assistance.sourceFoundings?.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Descripción</th>
              <td mat-cell *matCellDef="let assistance">
                {{ assistance.description }}
              </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>Total</th>
              <td mat-cell *matCellDef="let assistance">
                {{ assistance.total }}
              </td>
            </ng-container>

            <ng-container matColumnDef="servicesDetail">
              <td mat-cell *matCellDef="let assistance" [attr.colspan]="showColumns.length">
                @if (isExpanded(assistance.id)) {
                  <app-assistance-assistanceservice-list
                    [assistance]="assistance"
                    (changed)="fetchAssistance(page)"
                  ></app-assistance-assistanceservice-list>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: ['servicesDetail']"
              class="services-detail-row"
            ></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchAssistance($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
